export enum LoadingState {
    NONE = 'none',
    LOADING = 'loading',
    SUCCESS = 'success',
    FAILURE = 'failure',
}
